import { Injectable } from '@angular/core';
import {
  ColorMode,
  ColorModeRequests as ColorModeRequestsInterface,
} from '../features/color-mode';
import { EMPTY, Observable, of } from 'rxjs';
import { StateMemento } from 'wflow-cdk';
import { UserCustomizationAPIService } from '../core/api';
import {
  catchError,
  distinctUntilChanged,
  filter,
  startWith,
  switchMap,
  take,
  tap,
} from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ColorModeRequests implements ColorModeRequestsInterface {
  readonly storage = new StateMemento<ColorMode>({
    key: 'APP_COLOR_MODE',
    storage: localStorage,
  });

  constructor(
    private authSvc: AuthService,
    private userCustomizationSvc: UserCustomizationAPIService,
  ) {}

  getColorMode(): Observable<ColorMode> {
    let request$ = this.authSvc.isAuthorize$.pipe(
      filter((is) => is),
      take(1),
      switchMap(() =>
        this.userCustomizationSvc.getColorMode<ColorMode>().pipe(
          tap((value) => this.storage.change(value)),
          catchError(() => of(this.storage.state ?? 'auto')),
          take(1),
        ),
      ),
    );

    if (!!this.storage.state) {
      request$ = request$.pipe(startWith(this.storage.state));
    }

    return request$.pipe(distinctUntilChanged());
  }

  setColorMode(value: ColorMode): void {
    if (value === this.storage.state) {
      return;
    }

    if (value == null) {
      value = 'auto';
    }

    this.storage.change(value);
    this.userCustomizationSvc
      .setColorMode<ColorMode>(value)
      .pipe(catchError(() => EMPTY))
      .subscribe();
  }
}
